import type { HeroProps } from '@/components/PolicyTwo/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/transparency/transparency_report_og.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/PolicyTwo/policyTwo__en-DE.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['en-DE'].layout, showAskUsAnything: true },
  seo: {
    ...sharedConfig['en-DE'].seo,
    title: 'Policy 2.0 by Lemonade Insurance | Lemonade',
    description:
      "Introducing Policy 2.0 by Lemonade: A radically simplified, modernized, and digitized insurance policy. In line with our mantra of transforming insurance from a necessary evil into a social good, we'd love for everyone to contribute to and benefit from the world’s first open source insurance policy.",
    ogImage: og.src,
  },
  hero: {
    title: 'World’s First Open Source\nInsurance Policy',
    subtitle:
      'Policy 2.0 is a radically simplified, modernized, and digitized insurance policy. This means you can actually read and understand it!',
    ctaLabel: 'read the policy',
  },
  MDXContent: content as DocumentTypes,
};
